// extracted by mini-css-extract-plugin
export default {"bullets":"Tl1EsSSj","bullet":"xmmBYk6s"};